$(function() { 
  //$("a.learnMore").click(function() {  
  //    $(this).parent().toggleClass("open");
  //  });
  var $js_additionalInformation = $('.js_additionalInformation');
  var $additionalInformation = $('.additional-information');
  
  if($additionalInformation.length) {
  	
    $js_additionalInformation.prepend($additionalInformation).prepend('<h3>Additional information</h3>');

    var $js_learnMore = $('.js_learnMore');
    var $js_learnMoreContent = $('.js_learnMoreContent');
    
    $js_learnMoreContent.toggle();
    
    function showLearnMore() {
      
      var $theLi = $(this).closest('.additional-information li');
      
      $theLi.toggleClass('active');
      $theLi.find('.js_learnMoreContent').slideToggle();
         
      return false;
      
    }
    
    $js_learnMore.on('click',showLearnMore);
    
  }
});